import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfileService } from 'src/app/pages/app/profile/services/profile.service';

@Component({
	selector: 'app-not-started',
	templateUrl: './not-started.component.html',
	styleUrls: ['./not-started.component.scss'],
})
export class NotStartedComponent implements OnInit {
	profile$: Observable<any> = this.profileService.loadProfileData();

	@Input() startDate: any;

	constructor(private profileService: ProfileService) {}

	ngOnInit() {}
}
